import { Injectable } from '@angular/core';
import { ModalService } from '../shared/modal.service';
import { SharedAccountDialogComponent } from './shared-account-dialog/shared-account-dialog.component';
import { WindowService } from '../shared/window.service';

export const SHARING_ACCOUNT_PENDING_VALIDATION_KEY = '__oe_sharing_account_pending_validation';
export const SHARING_ACCOUNT_URL_KEY = '__oe_sharing_account_url';
@Injectable()
export class SharedAccountService {

  constructor(
    private readonly windowService: WindowService
  ) {}

  public init() {
    const isPendingValidation = JSON.parse(sessionStorage.getItem(SHARING_ACCOUNT_PENDING_VALIDATION_KEY));
    const url = sessionStorage.getItem(SHARING_ACCOUNT_URL_KEY);
    this.accountSharingGuard(isPendingValidation, url);
  }

  public accountSharingGuard(isPendingValidation: boolean, url: string) {
    const isInValidationPage = this.windowService.getHref().includes('/account-sharing.html');
    if (isPendingValidation && !isInValidationPage) {
      this.windowService.redirectToUrl('/account-sharing.html');
      this.setSharingAccountPendingValidationValue(true);
      this.setSharingAccountUrlValue(url || '/');
    }
  }

  public setSharingAccountPendingValidationValue(isPendingValidation: boolean) {
    sessionStorage.setItem(SHARING_ACCOUNT_PENDING_VALIDATION_KEY, JSON.stringify(isPendingValidation));
  }

  public removeSharingAccountPendingValidationValue() {
    sessionStorage.removeItem(SHARING_ACCOUNT_PENDING_VALIDATION_KEY);
  }

  public setSharingAccountUrlValue(url: string) {
    sessionStorage.setItem(SHARING_ACCOUNT_URL_KEY, url);
  }

  public removeSharingAccountUrlValue() {
    sessionStorage.removeItem(SHARING_ACCOUNT_URL_KEY);
  }

  public getSharingAccountUrlValue() {
    return sessionStorage.getItem(SHARING_ACCOUNT_URL_KEY);
  }

}



// WEBPACK FOOTER //
// ./ts/app/login/shared-account.service.ts